/*
  O backend guarda só a CHAVE do arquivo no Space; a URL é montada aqui, como o
  resto do projeto já faz.

  Em módulo próprio para o campo de foto e a miniatura usarem a mesma função sem
  um importar o outro.
*/
const BASE_SPACE = "https://redacoes.nyc3.digitaloceanspaces.com";

export const urlDaFoto = (chave) =>
  !chave ? null : chave.startsWith("http") ? chave : `${BASE_SPACE}/${chave}`;
